module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"add_media":"写真・動画を添付","add_photo":"写真を添付","max_media_count":"（最大{0}件）","media_count_exceeded":"最大{0}個までアップロード可能なため、選択した写真・動画のうち{1}個のみ添付されます。","capture_excluded":"スクリーンショットはアップロードできません。選択した写真・動画から除外して添付します。","capture_excluded_and_media_count_exceeded":"スクリーンショットを除き、写真・動画を{0}件まで添付します。"}}')
  delete Component.options._Ctor
}
